import { useStaticQuery, graphql } from 'gatsby';

const useTeams = (teams = ['All']) => {
  const teamQueries = {};
  const results = useStaticQuery(
    graphql`
      query TeamQuery {
        All: allPaperformHelpTeam {
          edges {
            node {
              ...teamFields
            }
          }
        }
        Operations: allPaperformHelpTeam(
          filter: { teams: { in: "Operations" } }
        ) {
          edges {
            node {
              ...teamFields
            }
          }
        }
        CustomerSuccess: allPaperformHelpTeam(
          filter: { teams: { in: "Customer Success" } }
        ) {
          edges {
            node {
              ...teamFields
            }
          }
        }
        Developers: allPaperformHelpTeam(
          filter: { teams: { in: "Developers" } }
        ) {
          edges {
            node {
              ...teamFields
            }
          }
        }
        Sales: allPaperformHelpTeam(filter: { teams: { in: "Sales" } }) {
          edges {
            node {
              ...teamFields
            }
          }
        }
        Partnerships: allPaperformHelpTeam(
          filter: { teams: { in: "Partnerships" } }
        ) {
          edges {
            node {
              ...teamFields
            }
          }
        }
        Growth: allPaperformHelpTeam(filter: { teams: { in: "Growth" } }) {
          edges {
            node {
              ...teamFields
            }
          }
        }
        Product: allPaperformHelpTeam(filter: { teams: { in: "Product" } }) {
          edges {
            node {
              ...teamFields
            }
          }
        }
        Design: allPaperformHelpTeam(filter: { teams: { in: "Design" } }) {
          edges {
            node {
              ...teamFields
            }
          }
        }
      }
      fragment teamFields on PaperformHelpTeam {
        name
        preferred_name
        show
        job_title
        teams
        about
        image
        alt_image
        carousel_image
        created_at
      }
    `,
  );

  teams.forEach((team) => {
    const keyName = team.replace(' ', '');
    const teamMembers = results[keyName].edges.sort(
      (a, b) => a.node.created_at - b.node.created_at,
    );
    teamQueries[team] = teamMembers;
  });

  return teamQueries;
};

export default useTeams;
